var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "carouselContainerRow",
      class: { carouselContainerCol: _vm.itemsWrap },
    },
    [
      _vm.items.length > 0
        ? _c("div", { staticClass: "button left" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                class: { hiddenBtn: _vm.counter <= 0 },
                attrs: { disabled: _vm.scrolling },
                on: { click: _vm.scrollLeft },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "40",
                      height: "40",
                      fill: "none",
                      stroke: "#0d0d0d",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2.5",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M15.375 5.25 8.625 12l6.75 6.75" },
                    }),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm.items.length > 0
        ? _c(
            "div",
            { ref: "carousel", staticClass: "models-carousel" },
            _vm._l(_vm.items, function (model, idx) {
              return _c(
                "div",
                {
                  key: idx,
                  staticClass: "item",
                  class: {
                    selected: _vm.activeElement == model.ItemCode,
                    "not-clickable":
                      _vm.itemsType === "coloriFrontali" &&
                      parseInt(model.GiacIta) < 1 &&
                      !model.ShipDateIta,
                  },
                  on: {
                    click: function ($event) {
                      !(
                        _vm.itemsType === "coloriFrontali" &&
                        parseInt(model.GiacIta) < 1 &&
                        !model.ShipDateIta
                      ) && _vm.selectItem(model)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "text" }),
                  _vm.itemsType === "lentiSole"
                    ? _c("div", { staticClass: "img" }, [
                        _c(
                          "div",
                          {
                            staticClass: "shape",
                            staticStyle: { width: "180px" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center flex-column",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mb-2",
                                    staticStyle: {
                                      width: "60%",
                                      position: "relative",
                                    },
                                  },
                                  [
                                    _c("v-img", {
                                      staticClass: "rounded-circle",
                                      class: {
                                        active: _vm.currentIndex === idx,
                                      },
                                      attrs: { src: model.imageUrl },
                                    }),
                                    _c("v-img", {
                                      staticStyle: {
                                        position: "absolute",
                                        left: "0",
                                        top: "0",
                                      },
                                      attrs: {
                                        src: require("../assets/LENS_REFLECTIONS.png"),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "img",
                          staticStyle: { position: "relative" },
                        },
                        [
                          _c("v-img", {
                            attrs: { contain: "", src: model.imageUrl },
                          }),
                          _vm.itemsType === "coloriFrontali" &&
                          parseInt(model.GiacIta) < 1 &&
                          !model.ShipDateIta
                            ? _c(
                                "span",
                                { staticClass: "color-finished-overlay" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("message.Colore_esaurito")
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                  _c(
                    "div",
                    {
                      staticClass: "text-name",
                      class: { selected: _vm.currentIndex === idx },
                    },
                    [_vm._v(" " + _vm._s(model.name) + " ")]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.items.length > 0
        ? _c("div", { staticClass: "button right" }, [
            _c(
              "button",
              {
                staticClass: "btn",
                class: { hiddenBtn: _vm.btnRight },
                attrs: { disabled: _vm.scrolling },
                on: { click: _vm.scrollRight },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "40",
                      height: "40",
                      fill: "none",
                      stroke: "#0d0d0d",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2.5",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "m8.625 5.25 6.75 6.75-6.75 6.75" },
                    }),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }